const CHECKOUT_MODE_STORAGE_KEY = 'trashie:subscription-unlimited-checkout-mode';
const CHECKOUT_MODE_EVENT_NAME = 'trashie:subscription-unlimited-checkout-mode-change';

const SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES = {
  OLD: 'old',
  NEW: 'new',
};

const normalizeCheckoutMode = (value) => (
  value === SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.NEW
    ? SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.NEW
    : SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.OLD
);

const canUseBrowserStorage = () => typeof window !== 'undefined' && window.localStorage;

function getSubscriptionUnlimitedCheckoutMode() {
  if (!canUseBrowserStorage()) {
    return SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.OLD;
  }

  return normalizeCheckoutMode(window.localStorage.getItem(CHECKOUT_MODE_STORAGE_KEY));
}

const dispatchCheckoutModeEvent = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(CHECKOUT_MODE_EVENT_NAME, {
    detail: {
      mode: getSubscriptionUnlimitedCheckoutMode(),
    },
  }));
};

function setSubscriptionUnlimitedCheckoutMode(mode) {
  if (!canUseBrowserStorage()) {
    return SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.OLD;
  }

  const normalizedMode = normalizeCheckoutMode(mode);
  window.localStorage.setItem(CHECKOUT_MODE_STORAGE_KEY, normalizedMode);
  dispatchCheckoutModeEvent();

  return normalizedMode;
}

function clearSubscriptionUnlimitedCheckoutMode() {
  if (!canUseBrowserStorage()) {
    return SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.OLD;
  }

  window.localStorage.removeItem(CHECKOUT_MODE_STORAGE_KEY);
  dispatchCheckoutModeEvent();

  return SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.OLD;
}

function installSubscriptionUnlimitedCheckoutWindowApi() {
  if (typeof window === 'undefined') {
    return;
  }

  window.trashieUnlimitedCheckout = {
    useOld: () => setSubscriptionUnlimitedCheckoutMode(
      SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.OLD,
    ),
    useNew: () => setSubscriptionUnlimitedCheckoutMode(
      SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES.NEW,
    ),
    reset: () => clearSubscriptionUnlimitedCheckoutMode(),
    getMode: () => getSubscriptionUnlimitedCheckoutMode(),
  };
}

export {
  CHECKOUT_MODE_STORAGE_KEY,
  CHECKOUT_MODE_EVENT_NAME,
  SUBSCRIPTION_UNLIMITED_CHECKOUT_MODES,
  getSubscriptionUnlimitedCheckoutMode,
  setSubscriptionUnlimitedCheckoutMode,
  clearSubscriptionUnlimitedCheckoutMode,
  installSubscriptionUnlimitedCheckoutWindowApi,
};
